import React, { useState } from 'react'
import Modal from 'components/modal'
import Button from 'components/button'
import { IApiKeyFieldConfig } from 'types'
import Input from 'components/input'

interface ApiKeyModalProps {
  open: boolean
  setOpen: (open: boolean) => void
  fields: IApiKeyFieldConfig[]
  onSubmit: (credentials: Record<string, string>) => void
  saving: boolean
}

const ApiKeyModal: React.FC<ApiKeyModalProps> = ({ open, setOpen, fields, onSubmit, saving }) => {
  const [values, setValues] = useState<Record<string, string>>({})
  const [error, setError] = useState<string>('')

  const handleSubmit = () => {
    for (const field of fields) {
      if (!values[field.key]?.trim()) {
        setError(`${field.label} is required`)
        return
      }
    }
    setError('')
    const trimmed: Record<string, string> = {}
    for (const field of fields) {
      trimmed[field.key] = values[field.key].trim()
    }
    onSubmit(trimmed)
  }

  const handleClose = () => {
    if (!saving) {
      setValues({})
      setError('')
      setOpen(false)
    }
  }

  return (
    <Modal id="api-key-credentials-modal" open={open} setOpen={handleClose} title="Enter Credentials">
      <div className="flex flex-col gap-3">
        {fields.map((field) => (
          <div key={field.key}>
            <label htmlFor={`api-key-${field.key}`} className="block text-sm font-medium mb-1">
              {field.label}
            </label>
            <Input
              id={`api-key-${field.key}`}
              type={field.isSecret ? 'password' : 'text'}
              placeholder={field.placeholder || field.label}
              value={values[field.key] || ''}
              onChange={(e) => setValues((prev) => ({ ...prev, [field.key]: e.target.value }))}
              className="border-divider px-3 py-2"
              disabled={saving}
            />
          </div>
        ))}
        {error && <div className="text-sm text-red">{error}</div>}
        <div className="flex items-center justify-end gap-2 mt-2">
          <Button internalType="secondary" onClick={handleClose} disabled={saving}>
            Cancel
          </Button>
          <Button onClick={handleSubmit} disabled={saving}>
            {saving ? 'Validating...' : 'Connect'}
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default ApiKeyModal
